import { fromJS } from 'immutable'
import {
  PROJECT_CODE_NON_SERVICE_GET_REQUEST,
  PROJECT_CODE_NON_SERVICE_GET_SUCCESS,
  PROJECT_CODE_NON_SERVICE_GET_FAILURE,
  PROJECT_CODE_NON_SERVICE_GET_RESET,
} from '../../actions/project-code/types'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
  project: {},
})

export default (state = init, action) => {
  switch (action.type) {
    case PROJECT_CODE_NON_SERVICE_GET_REQUEST:
      return state
        .set('isFetching', true)
    case PROJECT_CODE_NON_SERVICE_GET_SUCCESS:
      return state
        .set('project', fromJS(action.payload.project))
        .set('isFetching', false)
    case PROJECT_CODE_NON_SERVICE_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case PROJECT_CODE_NON_SERVICE_GET_RESET:
      return state
        .set('isFetching', false)
        .set('project', null)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project-code/project-non-service-get-reducer.js